import { getFunctions, httpsCallable } from "firebase/functions";
import { log } from "../../helper/helper";
import config from "./../../config.json";
import { getApp } from "firebase/app";


export function adminGetReportForCompleteTransport(startTime, endTime, cursorTransportId) {
    let data = {
        start_time: startTime,
        end_time: endTime
    };
    if (cursorTransportId !== "") {
        data.cursor_transport_id = cursorTransportId;
    }
    log(data);
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const allTransports = httpsCallable(functions, config.adminGetReportForCompleteTransport);
    return allTransports(data);
}

export function adminGetFinancialReportForTransports(startTime, endTime) {
    let data = {
        start_time: startTime,
        end_time: endTime
    }
    log(data);
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const allTransports = httpsCallable(functions, config.adminGetFinancialReportForTransports);
    return allTransports(data);
}